import '../style/store/S_Sort.css';
import { AiOutlineRise } from "react-icons/ai";


let data_list = [
  {
    id:1,
    name:"محبوب‌ترین‌ها",
    isAtive:true
  },
  {
    id:2,
    name:"پرفروش‌ترین‌ها",
    isAtive:false
  },
  {
    id:3,
    name:"پربازدیدترین‌ها",
    isAtive:false
  },
  {
    id:4,
    name:"جدیدترین‌ها",
    isAtive:false
  },
] 

const S_Sort=()=>{
  return(
    <div className="s_sort">
      <AiOutlineRise className="s-sort-icon"/>
      <div className="s-sort-items">
        {data_list.map(item=>(
          <div style={item.isAtive ? {color:"#2E81E8",fontWeight:"bold"}: null} key={item.id} className="s-s-i_item">
            {item.name}
          </div>
        ))}
      </div>
    </div>
  )
}

export default S_Sort;